import { Github, Linkedin, Mail } from "lucide-react";

const SOCIAL = [
  {
    href: "https://github.com/SalahAlDin2021",
    label: "GitHub",
    icon: Github,
  },
  {
    href: "https://www.linkedin.com/in/salah-al-din-d-b240491a7/",
    label: "LinkedIn",
    icon: Linkedin,
  },
  {
    href: "mailto:salahaldin.daraldeek@gmail.com",
    label: "Email",
    icon: Mail,
  },
];

export function Footer() {
  return (
    <footer className="border-t border-border/60 bg-background/60">
      <div className="mx-auto flex w-full max-w-6xl flex-col items-start justify-between gap-4 px-4 py-8 text-sm text-muted-foreground sm:flex-row sm:items-center sm:px-6">
        <div>
          <span className="font-serif text-foreground">Salahaldin Daraldik</span>
          <span className="ml-2 text-xs">— Software Developer · MSc Data Science</span>
        </div>
        <nav className="flex items-center gap-3">
          {SOCIAL.map((s) => (
            <a
              key={s.href}
              href={s.href}
              target="_blank"
              rel="noreferrer noopener"
              aria-label={s.label}
              className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-border transition hover:border-primary hover:text-primary"
            >
              <s.icon className="h-4 w-4" />
            </a>
          ))}
        </nav>
        <div className="text-xs">© {new Date().getFullYear()} — all rights reserved.</div>
      </div>
    </footer>
  );
}
